import styled from 'styled-components';
import { COLOR } from '@src/styles/color';

export const StyledCancelAutoRenewDialog = styled.div`
  width: 100%;
  height: 100%;
  background: ${COLOR.white};
`;
